import { Chip, withStyles } from "@material-ui/core";
import { colors, onboardingStatusColors } from "../../utils/colorCode";

const VerifiedStatusChip = withStyles({
  root: {
    height: "24px",
    '&[data-status="success"]': {
      backgroundColor: colors.greenBG,
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="danger"]': {
      backgroundColor: "#ffadb5",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="warn"]': {
      backgroundColor: colors.amberBG,
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="danger-dark"]': {
      backgroundColor: "transparent",
      color: "#be4408",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #be4408 !important",
    },
    '&[data-status="danger-outlined"]': {
      backgroundColor: "transparent",
      color: "#be4408",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #be4408 !important",
    },
    '&[data-status="success-outlined"]': {
      backgroundColor: "transparent",
      color: "#0028fa",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #0028fa !important",
    },
    '&[data-status="success-outlined-sm"]': {
      backgroundColor: "transparent",
      color: "#0028fa",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #0028fa !important",
      fontSize: 12,
      padding: 0,
    },
    '&[data-status="light"]': {
      backgroundColor: "rgb(237 244 255)",
      color: "#4d4d4d",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="primary"]': {
      backgroundColor: "#2563eb",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="dark"]': {
      backgroundColor: "#0a0a29",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="profile-input"]': {
      backgroundColor: "rgb(237 244 255)",
      color: "#0a0a29",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      height: "38px",
      fontWeight: 600,
    },
    '&[data-status="profile-warn"]': {
      backgroundColor: "#ffd2a5",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      height: "38px",
      fontWeight: 600,
    },
    '&[data-status="Prospecting"]': {
      backgroundColor: "#C5E3FF",
      color: "#0a0a29",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="First Contact"]': {
      backgroundColor: "#9CD0FF",
      color: "#0a0a29",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Viewing"]': {
      backgroundColor: "#f5d6b6",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Viewing Outcome"]': {
      backgroundColor: "#FFB800",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Assessment"]': {
      backgroundColor: "#a9d7bb",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Assessment Outcome"]': {
      backgroundColor: "#70BB63",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Closed"]': {
      backgroundColor: "#C4C4C4",
      color: "#4d4d4d",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="pending"]': {
      backgroundColor: colors.amberDarkBG,
      color: colors.amberDarkBorder,
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="approved"]': {
      backgroundColor: colors.greenBG,
      color: colors.greenBorder,
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="rejected"]': {
      backgroundColor: colors.redBG,
      color: colors.redBorder,
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="correction_requested"]': {
      backgroundColor: colors.blueBG,
      color: colors.blueBorder,
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="draft"]': {
      backgroundColor: onboardingStatusColors.draft,
      color: "#444444",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="submitted"]': {
      backgroundColor: onboardingStatusColors.submitted,
      color: "#8A2E58",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="in progress"]': {
      backgroundColor: onboardingStatusColors["in progress"],
      color: "#8A6A2E",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="awaiting hr approval"]': {
      backgroundColor: onboardingStatusColors["awaiting hr approval"],
      color: "#5A3D8A",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="request for final review"]': {
      backgroundColor: onboardingStatusColors["request for final review"],
      color: "#8A3D7A",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="hr approved"]': {
      backgroundColor: onboardingStatusColors["hr approved"],
      color: "#2E6A8A",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="completed"]': {
      backgroundColor: onboardingStatusColors.completed,
      color: "#276A42",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="revisions required"]': {
      backgroundColor: onboardingStatusColors["revisions required"],
      color: "#2E4D8A",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="skipped"]': {
      backgroundColor: onboardingStatusColors.skipped,
      color: "#8A3D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[text-style="info"]': {
      textTransform: "initial",
    },
    '&[data-status="shift"]': {
      backgroundColor: "#3B82F6",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="shift-claimable"]': {
      backgroundColor: "#10B981",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="shift-orange"]': {
      backgroundColor: "#FF8B07",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="shift-red"]': {
      backgroundColor: "#FF4141",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
  },
})(Chip);
export default VerifiedStatusChip;
